<div class="toast-container position-fixed bottom-0 start-0 p-3">
  @for (toast of toasts(); track $index) {
    <cert-toast [toastConfig]="toast" />
  }
</div>
